import { axios } from '@/utils/request'
const api = {
  provinceStatistics: '/order/dataCenter/'
}
export function getProvinceStatistics (parameter) {
  return axios({
    url: api.provinceStatistics + 'provinceStatistics',
    method: 'get',
    params: parameter
  })
}
export function getcityStatistics (parameter) {
  return axios({
    url: api.provinceStatistics + 'cityStatistics',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
